import {Component, ElementRef, Inject, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormModel, FormState, FormType} from '../../../models';
import {EmailGenericComponent} from '../email-generic/email-generic.component';
import {FormulaireService} from '../../../../../services/formulaire/formulaire.service';
import {AttachmentsFormModel, CategorieDemat} from "../../../models/formdemat.model";
import {Constants} from "../../common/constants";
import {SnackBarToastyService, typeToast} from "@Common/widgets/general/snack-bar";
import {SubSink} from "@Common/core/utils/subsink";
import * as FileSaver from "file-saver";
import {MessageActionModel} from "@Common/neo-components/message/message-action.model";
import {MessageEnum} from "@Common/neo-components/message/message-enum";
import {CategorieService} from "../../../../../services/formulaire/categorie.service";
import {ModalCategorieComponent} from "../form-categorie/cat-modal/modal-categorie/modal-categorie.component";



/**
 * Edition titre / description formulaire ou bloc
 */
@Component({
  selector: 'app-dm-form-modal',
  templateUrl: './form-modal.component.html',
  styleUrls: ['./form-modal.component.scss']
})
export class FormModalComponent {
  item: FormModel;
  formState = FormState;
  administratifBlockExist = false;
  titleModale = '';
  confirmButtonText = 'Yes';
  cancelButtonText = '';
  titreMaxLen = 80;
  descriptionMaxLen = 250;
  signatureMinLen = 3;
  signatureMaxLen = 120;
  isPublicBlock: boolean;
  blockedButton = true;
  minDate = new Date();
  formType = FormType;
  constants: any = Constants;
  filesToUpload: AttachmentsFormModel[] = [];
  allowedExtensions = this.constants.allowedExtensionsFile;
  allowMultiple = !this.constants.allowMultiple;
  subSink = new SubSink();
  messageActions: MessageActionModel[] = [];
  messageType = MessageEnum;
  categoriesList: CategorieDemat[] = [];
  @ViewChild('emailGeneric') emailGeneric: EmailGenericComponent;
  @ViewChildren('fileInput') inputFiles: QueryList<ElementRef>;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<FormModalComponent>,
    private snackSvc: SnackBarToastyService,
    private categorieSvc: CategorieService,
    private formSvc: FormulaireService) {
    if (data) {
      this.item = data.form || this.item;
      this.filesToUpload = this.item['attachments_obj'] || [];
      this.titleModale = data.titleModale || this.titleModale;
      if (data.buttonText) {
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        if (data.buttonText.cancel) {
          this.cancelButtonText = data.buttonText.cancel;
        }
      }
      if (!this.item.categories) {
        this.item.categories = [];
      }
      this.subSink.sink = this.categorieSvc.listAllItems()
        .subscribe(result => {
          this.categoriesList = result.list?.filter(cat => cat.active);
        });
    }
  }


  uploadFile(event) {
    const files = event.target.files;
    const validFiles = [];

    for (let i = 0; i < files.length; i++) {
      if (files[i].size <= this.constants.maxSize) {  // If file size is less than 15MB
        validFiles.push(files[i]);
      } else {
        this.snackSvc.toasty(
          `${files[i].name}`,
          this.constants.notificationMessage.maxSizeFileWarning,
          typeToast.warning, 5000);
      }
    }

    this.filesToUpload.push(...validFiles);
  }

  downloadSelectedFile(file) {
    if(!this.checkIfIsFile(file)) {
      this.subSink.sink = this.formSvc.downloadAttachement(file).subscribe(v => FileSaver.saveAs(v, file.name));
    }
  }
  /**
   * Pour vérifié si le file est un fichier ou une donné de la BD :
   * @param file
   */
  checkIfIsFile(file) {
    return (file instanceof File);
  }

  clearSelectedFile(index: number, fileId = 0) {
    if(fileId > 0){
      this.subSink.sink = this.formSvc.deleteFile(fileId).subscribe();
    }
    this.filesToUpload.splice(index, 1);
  }

  getEnumTypeForm() {
    return Object.values(FormType).filter(element => !isNaN(Number(element)))
                  .sort();
  }

  /**
   * Le formulaire a-t-il bien une signature, un nom et le format du mail générique est-il bon ?
   */
  isBlockedForNameSignatureEmailGeneric() {

    const minNonSpaceChars = this.signatureMinLen;

    // Vérifiez si signature_email contient au moins le nombre spécifié de caractères autres que des espaces
    const trimmedSignatureEmail = this.item?.signature_email?.trim(); // enlever les caractères espace début et fin
    const signatureEmailContainsRequiredChars = trimmedSignatureEmail && new RegExp(`\\S{${minNonSpaceChars},}`).test(trimmedSignatureEmail);

    return this.emailGeneric &&
      (!this.item?.nom || !this.item?.signature_email || !signatureEmailContainsRequiredChars || !this.emailGeneric.isEmailValid());
  }

  /**
   * La date de fin est-elle bien saisie dans le cadre d'un Sondage ?
   */
  isBlockedForDateFin() {
    return (this.item.type === FormType.Sondage && this.item.date_fin === null);
  }
  onCloseClick(go = false): void {
    if (go) {
      this.item.date_debut = this.formSvc.formatDateToSql(this.item.date_debut);
      this.item.date_fin = this.formSvc.formatDateToSql(this.item.date_fin);
    }
    const validFiles = this.filesToUpload.filter(this.checkIfIsFile);
    if (validFiles && validFiles.length > 0) {
      this.item.attachments = validFiles;
    }

    this.dialogRef.close(go ? this.item : false);
    this.subSink.unsubscribe();
  }

  onEmailSend(email) {
    (<FormModel> this.item).email_generic = email;
  }

  checkAction(event) {
    switch(event.actionIdentifier) {
      case 'downloadFile': {
        this.downloadSelectedFile(event.actionData.file);
        break;
      }
      case 'clearFile': {
        this.clearSelectedFile(event.actionData.fileIndex, event.actionData.fileId);
        break;
      }
      default: {
        break;
      }
    }
  }

  getActions(file: AttachmentsFormModel, fIdx: number): MessageActionModel[] {
    return [
      { icon: 'clear', actionIdentifier: 'clearFile', actionData: {fileIndex: fIdx, fileId: file['id']}, disabled: false},
      { icon: 'download', actionIdentifier: 'downloadFile', actionData: {file: file}, disabled: this.checkIfIsFile(file)}]
  }

  onAddCategorie(e: Event) {
    e.stopPropagation();
    const dialogRef = this.dialog.open(ModalCategorieComponent, {
      data: {
        mode: 'create',
        buttonText: { ok: 'Créer' }
      }
    });

    dialogRef.afterClosed().subscribe((newCat: CategorieDemat) => {
      if (newCat) {
        this.categorieSvc.updateOrcreate(newCat).subscribe((created: CategorieDemat) => {

          // add to list
          this.categoriesList = [...this.categoriesList, created];

          // auto-select it
          this.item.categories = [
            ...(this.item.categories || []),
            created.id
          ];
        });
      }
    });
  }
}
